var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"i-label-main d-flex align-center"},[_c('v-icon',{attrs:{"small":"","color":"blue"}},[_vm._v("mdi-circle")]),_c('span',{staticClass:"pa-1 label-text"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }